import { selectActiveFeature } from '../../../Map/selectors';
import { TFeature, TFeatureWithPrecision } from '../../types/map';
import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EFeaturesActionType } from '../features/types';
import { updateFeatureProperties } from '../updateFeatureProperties/updateFeatureProperies';

export const setSelectedFeature = actionGenerator<EFeaturesActionType.FeatureSelected, TFeatureWithPrecision | null>(
  EFeaturesActionType.FeatureSelected,
);

export function selectFeature(feature: TFeature, precision: number): TThunkAction {
  return (dispatch, getState) => {
    const activeFeature = selectActiveFeature(getState());

    dispatch(setSelectedFeature({ ...feature, precision }));

    if (activeFeature) {
      dispatch(
        updateFeatureProperties({
          featureId: activeFeature.id,
          precision: activeFeature.precision,
          properties: { isActive: false },
        }),
      );
    }
    dispatch(updateFeatureProperties({ featureId: feature.id, precision, properties: { isActive: true } }));
  };
}
